import {
  Autocomplete,
  DialogContent,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
} from "@mui/material";
import { Formik } from "formik";
import MDButton from "components/MDButton";
import MDDialog from "components/MDDialog";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import { useMaterialUIController } from "context";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import CircularIndeterminate from "components/MDLoading";
import { getAssignRatesByPlaceId } from "store/slice/rates/rateSlice";
import { getCalenderDataByPlaceId } from "store/slice/rates/rateSlice";
import { getAssignRatesTableDataByPlaceId } from "store/slice/rates/rateSlice";
import MDDropDown from "components/MDDropDown";
import { spaceBasedRates } from "store/slice/rates/rateSlice";

const AssignRatesToSpace = (props) => {
  const formikRef = useRef(null);
  const { dialogOpen, onClose, placeId, ratesData, spacesData } = props;
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });

  const handleAssignRates = async (rateData) => {
    try {
      setIsLoading(true);
      const res = await dispatch(spaceBasedRates(rateData)).unwrap();
      const success = res?.success;
      setNotification({
        ...notification,
        color: success ? "success" : "error",
        title: success ? "Success" : "Error",
        content: res?.message || "An unexpected error occurred.",
        icon: success ? "check" : "warning",
        show: true,
      });
      if (success) {
        await dispatch(getAssignRatesByPlaceId(placeId));
        await dispatch(getCalenderDataByPlaceId(placeId));
        await dispatch(getAssignRatesTableDataByPlaceId(placeId));

        onClose();
      }
    } catch (err) {
      console.error("Error assigning rate:", err);
      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: err?.message || "An error occurred while assigning rates.",
        icon: "warning",
        show: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CircularIndeterminate
        type="full"
        size={20}
        text={"Please wait..!"}
        open={isLoading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
      <MDDialog
        dialogTitle="Assign Rate To Space"
        open={dialogOpen}
        dialogClose={onClose}
        closeIcon={true}
        maxWidth="sm"
      >
        <DialogContent>
          <Formik
            innerRef={formikRef}
            initialValues={{
              spaceType: "primary",
              rateIds: [],
              rateArray: [],
              spaceIds: [],
              spaceArray: [],
            }}
            onSubmit={(value, action) => {
              console.log("value ====>", value);
              const payload = {
                placeId,
                rateIds: value?.rateIds,
                spaceIds: value?.spaceIds,
                isSpacePrimary: value?.spaceType === "primary",
              };
              console.log("payload ====>", payload);
              handleAssignRates(payload);
            }}
          >
            {(props) => {
              const handleSpaceTypeChange = (e) => {
                const spaceType = props.values.spaceType;
                const filteredSpaces = spacesData.filter((space) =>
                  spaceType === "primary" ? !space.isPrimary : space.isPrimary
                );
                props.setValues({
                  ...props.values,
                  spaceType: e.target.value,
                  spaceIds: filteredSpaces.map((s) => s._id),
                  spaceArray: filteredSpaces,
                });
              };

              const filteredRates = ratesData.filter(
                (rate) => rate.isUnitParking
              );

              return (
                <form onSubmit={props.handleSubmit}>
                  <Grid container spacing={2} className="mt-1">
                    <Grid item xs={12} md={12} lg={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Space Type
                        </InputLabel>
                        <MDDropDown
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="spaceType"
                          value={props.values.spaceType}
                          label="Space Type"
                          onChange={handleSpaceTypeChange}
                          onBlur={props.handleBlur}
                        >
                          <MenuItem value="primary">Primary</MenuItem>
                          <MenuItem value="additional">Additional</MenuItem>
                        </MDDropDown>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        multiple
                        disableClearable
                        name="spaceId"
                        value={props.values?.spaceArray}
                        options={spacesData.filter((space) =>
                          props.values.spaceType === "primary"
                            ? space.isPrimary
                            : !space.isPrimary
                        )}
                        onChange={(event, newValues) => {
                          props.setValues({
                            ...props?.values,
                            spaceIds: newValues?.map(({ _id }) => _id),
                            spaceArray: newValues,
                          });
                        }}
                        onBlur={props.handleBlur}
                        getOptionLabel={(option) => option?.title}
                        renderInput={(params) => (
                          <MDInput
                            label="Select Space"
                            fullWidth={true}
                            {...params}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={index}
                              variant="contained"
                              label={option?.title}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        multiple
                        disableClearable
                        name="rateId"
                        value={props.values?.rateArray}
                        options={ratesData}
                        onChange={(event, newValues) => {
                          props.setValues({
                            ...props?.values,
                            rateIds: newValues?.map(({ _id }) => _id),
                            rateArray: newValues,
                          });
                        }}
                        onBlur={props.handleBlur}
                        getOptionLabel={(option) =>
                          `${option.displayName} ${
                            option.title ? `(${option.title})` : ""
                          }`
                        }
                        renderInput={(params) => (
                          <MDInput
                            label="Select Rate"
                            fullWidth={true}
                            {...params}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={index}
                              variant="contained"
                              label={`${option.displayName} ${
                                option.title ? `(${option.title})` : ""
                              }`}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </Grid>

                    <Grid item xs={12} className="text-right">
                      <MDButton
                        color={sidenavColor}
                        variant="contained"
                        type="submit"
                      >
                        Create
                      </MDButton>
                    </Grid>
                  </Grid>
                </form>
              );
            }}
          </Formik>
        </DialogContent>
      </MDDialog>
    </>
  );
};

export default AssignRatesToSpace;
